import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://hjbesukqkbayzwsqetby.supabase.co";
const supabaseAnonKey = "sb_publishable_PyXqMwiTzqTAdxqjkF68VQ_YRaliCPY";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);